import React, { useState, useEffect } from 'react';
import { Select, Button, InputNumber } from 'antd';
import { SimpleTable } from '../../components';
import './style';
import { getDatetime } from '../../services/Login';

export default React.forwardRef((props, ref) => {
  const { goodsCategory, precision, onCloseCallback, onSaveCallback, getGoodsList } = props;
  const [rows, setRows] = useState([]);
  const [operater, setOperater] = useState(undefined);
  const [parameter, setParameter] = useState(undefined);
  const [startTime, setStartTime] = useState(undefined);
  const [categoryId, setCategoryId] = useState(undefined);
  const [prefix, setPrefix] = useState([]);

  const filterRows = () => {
    let temp = [].concat(rows);
    if (categoryId > 0) {
      temp = temp.filter(x=>x.category_id === categoryId);
    }
    if (prefix && prefix.length>0) {
      temp = temp.filter(x=>prefix.find(y=>y===x.prefix));
    }
    return temp;
  }

  const onChangeCategoryId = (id) => {
    setCategoryId(id);
    setPrefix([]);
    let temp = [].concat(rows);
    temp.forEach(x=>x.selected = false);
    setRows(temp);
  }

  const onChangePrefix = (arr) => {
    setPrefix(arr);
  }
  useEffect(() => {
    getGoodsList && getDatetime().then(dt => {
      getGoodsList(dt).then(data => setRows(data));
      setStartTime(dt);
    });
  }, []);

  useEffect(()=>{
    const target = filterRows();
    let temp = [].concat(rows);
    temp.forEach(x=> {
      if (target.find(y=>y.goods_id === x.goods_id && y.goods_spec_id === x.goods_spec_id)) {

      } else {
        x.selected = false;
      }
    })

    setRows(temp);
  }, [prefix]);

  const onSelectAll = (checked) => {
    const target = filterRows();
    let temp = [].concat(rows);
    temp.forEach(x=>x.selected = false);
    temp.filter(x=>target.find(y=>y.goods_id === x.goods_id && y.goods_spec_id === x.goods_spec_id)).forEach(z=> {
      z.selected = checked
    });
    setRows(temp);
  }

  const onSetSelected =(checked, index) => {
    const target = filterRows()[index];
    const temp = [].concat(rows);
    let selected = temp.find(x=>x.goods_id === target.goods_id && x.goods_spec_id === target.goods_spec_id);
    selected.selected = checked;
    setRows(temp);
  }

  const setSelected = (selected) => {
    const temp = [].concat(rows);
    (selected || []).forEach((x, i) => {
      temp[i].selected = x;
    });
    setRows(temp);
  }

  const onChangeoperater = (operater) => {
    setOperater(operater);
  }
  const onChangeParameter = (parameter) => {
    setParameter(parameter);
  }

  const calculate = () => {
    if (operater === undefined || parameter === undefined) return;
    const temp = [].concat(rows);
    temp.filter(x => x.selected).forEach((y, i) => {
      const find = temp.find(z => z.goods_spec_id === y.goods_spec_id);
      if (find.new_price !== undefined) {
        if (operater === 1) {
          find.new_price = find.new_price + parameter;
        } else if (operater === 2) {
          find.new_price = find.new_price - parameter;
        } else if (operater === 3) {
          find.new_price = find.new_price * parameter;
        } else if (operater === 4) {
          find.new_price = find.new_price / parameter;
        } else {
          find.new_price = parameter;
        }
      } else {
        if (operater === 1) {
          find.new_price = find.price + parameter;
        } else if (operater === 2) {
          find.new_price = find.price - parameter;
        } else if (operater === 3) {
          find.new_price = find.price * parameter;
        } else if (operater === 4) {
          find.new_price = find.price / parameter;
        } else {
          find.new_price = parameter;
        }
      }
      if (find.new_price)
        find.new_price = find.new_price;
    });
    setRows(temp);
    setOperater(undefined);
    setParameter(undefined);
  }

  const reset = () => {
    const temp = [].concat(rows);
    temp.forEach((_, idx) => {
      temp[idx].new_price = undefined;
    });
    setRows(temp);
  }

  const onSave = async () => {
    const valid = (rows || []).filter(x => x.new_price).map(y => ({
      goods_name: y.goods_name,
      goods_spec_name: y.goods_spec_name,
      goods_id: y.goods_id,
      goods_spec_id: y.goods_spec_id,
      price: y.new_price.toFixed(precision),
      start_time: startTime,
      end_time: '2099-12-31 23:59:59'
    }));
    onSaveCallback && onSaveCallback(valid, onCloseCallback);
  }

  const categories = () => {
    return goodsCategory.filter(x => rows.filter(y => y.category_id === x.id).length > 0);
  }
  const prefixs = () => {
    const temp = [];
    let filtered = [].concat(rows);
    if (categoryId > 0) {
      filtered = filtered.filter(x=>x.category_id === categoryId);
    }
    for (let i=0; i<filtered.length; i++) {
      const x = filtered[i];
      if (!temp.find(y => y === x.prefix)) {
        temp.push(x.prefix);
      }
    }
    return temp;
  }

  const header = [
    {
      label: '产品号', width: '120px', item: 'goods_spec_name'
    },
    {
      label: '产品名', width: '100px', item: 'goods_name'
    },
    {
      label: '产品尺寸', width: '60px', item: 'size'
    },
    {
      label: '件数/箱', width: '60px', align: 'right', item: 'pcs_per_carton'
    },
    {
      label: '箱数/托', width: '60px', align: 'right', item: 'carton_count_per_pallet'
    },
    {
      label: '当前价格', width: '60px', align: 'right', item: 'price'
    },
    {
      label: '计算后价格', width: '60px', align: 'right', item: 'new_price', render: (text, row, index) => {
        if (row.new_price <= 0) {
          return <span style={{ color: 'red' }}><strong>{text}</strong></span>
        } else {
          return <span><strong>{text && text.toFixed(precision)}</strong></span>
        }
      }
    },
    {
      label: '变化大小', width: '60px', align: 'right', item: 'new_price', render: (text, row, index) => {
        if (row.new_price - row.price > 0) {
          return <span style={{ color: 'red' }}>{(row.new_price - row.price).toFixed(precision)}</span>
        } else if (row.new_price - row.price < 0) {
          return <span style={{ color: 'green' }}>{(row.new_price - row.price).toFixed(precision)}</span>
        } else {
          return undefined;
        }
      }
    }
  ];



  return <div>
    <div style={{ backgroundColor: 'rgb(220, 222, 245)', padding: '0.5rem 1rem', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
      <span>基于当前下列显示价格进行&nbsp;
        <Select onChange={onChangeoperater} value={operater} style={{ width: '92px' }}>
          <Select.Option key={1} value={1}>
            加(+)
          </Select.Option>
          <Select.Option key={2} value={2}>
            减(-)
          </Select.Option>
          <Select.Option key={3} value={3}>
            乘(×)
          </Select.Option>
          <Select.Option key={4} value={4}>
            除(÷)
          </Select.Option>
          <Select.Option key={5} value={5}>
            等于(=)
          </Select.Option>
        </Select>
        <InputNumber onChange={onChangeParameter} value={parameter}></InputNumber>&nbsp;&nbsp;
        <Button disabled={(rows || []).filter(x => x.selected).length === 0 || operater === undefined || parameter === undefined} onClick={calculate} type="primary">执行计算</Button>&nbsp;&nbsp;
        <Button disabled={(rows || []).filter(x => x.new_price !== undefined).length === 0} onClick={reset}>重置价格</Button></span>
      <span>
        <Button disabled={(rows || []).filter(x => x.new_price).length === 0} onClick={onSave} type="primary">保存到数据库</Button>
      </span>
    </div>
    <div style={{ padding: '1rem' }}>
      筛选：<strong>报关品名: </strong><Select onChange={onChangeCategoryId} size="small" showSearch optionFilterProp="children" allowClear style={{ width: '120px', padding: '0.5rem 0' }}>
        {
          (categories() || []).map(x => {
            return <Select.Option key={x.id} value={x.id}>
              {x.name}
            </Select.Option>
          })
        }
      </Select>
        &nbsp;&nbsp;&nbsp;&nbsp;<strong>产品前缀: </strong><Select mode="multiple" value={prefix} onChange={onChangePrefix} size="small" showSearch optionFilterProp="children" allowClear style={{ width: '520px' }}>
        {
          (prefixs() || []).map(x => {
            return <Select.Option key={x} value={x}>
              {x}
            </Select.Option>
          })
        }
      </Select>
      <SimpleTable
        onSetSelected={onSetSelected}
        onSelectAll={onSelectAll}
        isPaginition={false}
        hasCheckbox={true}
        header={header}
        isLoading={rows === undefined}
        rows={filterRows()}>
      </SimpleTable>
    </div>
  </div>
});
